export default "__VITE_ASSET__CCvYutoF__"